var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 11,
    fill: "none",
    viewBox: "0 0 10 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#090707",
    d: "M1.8815 7.5H9V1.5H1V8.1925L1.8815 7.5ZM2.2275 8.5L0 10.25V1C0 0.867392 0.0526784 0.740215 0.146447 0.646447C0.240215 0.552678 0.367392 0.5 0.5 0.5H9.5C9.63261 0.5 9.75979 0.552678 9.85355 0.646447C9.94732 0.740215 10 0.867392 10 1V8C10 8.13261 9.94732 8.25979 9.85355 8.35355C9.75979 8.44732 9.63261 8.5 9.5 8.5H2.2275ZM4.5 6H5.5V7H4.5V6ZM3.2835 3.4065C3.34846 3.0814 3.50441 2.78142 3.7332 2.54149C3.96199 2.30155 4.25421 2.13152 4.57585 2.05118C4.8975 1.97084 5.23535 1.98349 5.55009 2.08766C5.86483 2.19183 6.14352 2.38324 6.35373 2.63961C6.56393 2.89598 6.69701 3.20678 6.73748 3.53583C6.77795 3.86488 6.72414 4.19866 6.58232 4.49832C6.44049 4.79799 6.21649 5.05122 5.93637 5.22855C5.65625 5.40588 5.33153 5.50001 5 5.5H4.5V4.5H5C5.14204 4.49999 5.28116 4.45965 5.40116 4.38366C5.52117 4.30768 5.61713 4.19918 5.67789 4.07079C5.73864 3.9424 5.76168 3.7994 5.74434 3.65842C5.727 3.51745 5.66998 3.38429 5.57992 3.27446C5.48986 3.16462 5.37046 3.08261 5.23561 3.03798C5.10077 2.99335 4.95602 2.98793 4.81821 3.02235C4.68041 3.05677 4.55521 3.12962 4.45718 3.23241C4.35916 3.3352 4.29234 3.46372 4.2645 3.603L3.2835 3.4065Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.2727f9e09c9dddd520d19eb2143b56f3.svg";
export { ForwardRef as ReactComponent };